import actions from './actions';
import mutations from './mutations';

export default {
  state: {
    accounts: [],
    newAccount: {}, // Used when creating new accounts.
  },
  mutations,
  actions,
  getters: {},
};
